// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_jr-0";
export var fileCarousel = "_jr-2";
export var removeFileButton = "_jr-1";